import {DOCUMENT} from "@angular/common";
import {inject, Injectable} from '@angular/core';
import {Meta, MetaDefinition, Title} from "@angular/platform-browser";

export const DEFAULT_WEBSITE_IMAGE_URL = 'https://collectoria.bg/assets/og-image.jpg';
export const DEFAULT_WEBSITE_IMAGE_WIDTH = '1200';
export const DEFAULT_WEBSITE_IMAGE_HEIGHT = '630';

@Injectable({
  providedIn: 'root'
})
export class MetaTagService {
  private metaService: Meta = inject(Meta);
  private titleService: Title = inject(Title);
  private document: Document = inject(DOCUMENT);

  public updateTag(tag: MetaDefinition) {
    this.metaService.updateTag(tag);
  }

  public removeTag(attr: string, value: string): void {
    this.metaService.removeTag(`${attr}="${value}"`);
  }

  public setTitle(title: string): void {
    this.titleService.setTitle(title);
    this.metaService.updateTag({property: 'og:title', content: title});
    this.metaService.updateTag({name: 'twitter:title', content: title});
  }

  public setDescription(description: string): void {
    this.metaService.updateTag({name: 'description', content: description});
    this.metaService.updateTag({name: 'twitter:description', content: description});
    this.metaService.updateTag({property: 'og:description', content: description});
  }

  public setCanonicalUrl(url: string): void {
    let link: HTMLLinkElement | null = this.document.querySelector('link[rel="canonical"]');
    if (link) {
      link.href = url;
    } else {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', url);
      this.document.head.appendChild(link);
    }
    this.metaService.updateTag({property: 'og:url', content: url});
  }

  public setMainTags(): void {
    this.metaService.updateTag({name: 'author', content: 'Нумизмат ЕООД'});
    this.metaService.updateTag({name: 'viewport', content: 'width=device-width, initial-scale=1'});
    this.metaService.updateTag({name: 'robots', content: 'index, follow'});

    this.metaService.updateTag({name: 'twitter:site', content: '@CollectoriaBG'});
    this.metaService.updateTag({name: 'twitter:creator', content: '@CollectoriaBG'});
    this.metaService.updateTag({name: 'twitter:card', content: 'summary_large_image'});
    this.metaService.updateTag({name: 'twitter:image', content: DEFAULT_WEBSITE_IMAGE_URL});

    this.metaService.updateTag({property: 'og:type', content: 'website'});
    this.metaService.updateTag({property: 'og:image', content: DEFAULT_WEBSITE_IMAGE_URL});
    this.metaService.updateTag({property: 'og:image:type', content: 'image/jpeg'});
    this.metaService.updateTag({property: 'og:image:alt', content: 'Collectoria'});
    this.metaService.updateTag({property: 'og:image:width', content: DEFAULT_WEBSITE_IMAGE_WIDTH});
    this.metaService.updateTag({property: 'og:image:height', content: DEFAULT_WEBSITE_IMAGE_HEIGHT});
    this.metaService.updateTag({property: 'og:site_name', content: 'Collectoria'});
    this.metaService.updateTag({property: 'og:locale', content: 'bg_BG'});
    this.metaService.updateTag({property: 'og:locale:alternate', content: 'en_US'});
    this.metaService.updateTag({property: 'og:updated_time', content: '2025-01-01'});
  }
}
